import {User} from '../security/user';
import * as moment from 'moment';

export class SearchModel {

  actionTypes: Array<number>;
  fromDate: string;
  toDate: string;
  objectTypes: Array<number>;
  objectId: number;
  author: number;

  page: number;
  size: number;

  constructor() {
    this.fromDate = null;
    this.toDate = null;
    this.actionTypes = [];
    this.objectTypes = [];
    this.author = null;
    this.objectId = null;
  }

  addDates(dates: Date[]): any {
    const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
    if (dates !== undefined && dates !== null && dates.length > 0) {
      this.fromDate = moment(dates[0]).format(DEFAULT_DATE_FORMAT);
      if (dates.length === 2) {
        if (dates[1] == null) {
          this.toDate = moment(dates[0]).format(DEFAULT_DATE_FORMAT);
        } else {
          this.toDate = moment(dates[1]).format(DEFAULT_DATE_FORMAT);
        }
      }
    } else {
      this.fromDate = null;
      this.toDate = null;
    }
    // if (filterData[key] instanceof Object &&
    //   filterData[key].length === 2 &&
    //   filterData[key][0] instanceof Date &&
    //   filterData[key][1] instanceof Date
    // ) {
    //   const from = moment(filterData[key][0]);
    //   from.set({hour: 0, minute: 0, second: 0});
    //   filterData[key + 'From'] = from.format(DEFAULT_DATE_FORMAT);
    //   const to = moment(filterData[key][1]);
    //   to.set({hour: 23, minute: 59, second: 59});
    //   filterData[key + 'To'] = to.format(DEFAULT_DATE_FORMAT);
    //   delete filterData[key];
    // } else if (filterData[key] instanceof Object &&
    //   filterData[key].length === 2 &&
    //   filterData[key][0] instanceof Date &&
    //   !filterData[key][1]) {
    //   const from = moment(filterData[key][0]);
    //   from.set({hour: 0, minute: 0, second: 0});
    //   filterData[key + 'From'] = from.format(DEFAULT_DATE_FORMAT);
    //   const to = moment(filterData[key][0]);
    //   to.set({hour: 23, minute: 59, second: 59});
    //   filterData[key + 'To'] = to.format(DEFAULT_DATE_FORMAT);
    //   delete filterData[key];
    // }
  }

  addObjectTypes(arr: Array<ObjectTypeI>) {
    this.objectTypes = [];
    this.objectTypes = arr.map(a => a.value);
  }
}

export enum ActionType {
  CREATE,
  UPDATE,
  DELETE
}

export interface TrackChangeDetail {
  // ChangeLogDetailData.java
  id: number;
  objectId: number;
  objectType: ObjectType;
  creationDate: Date;
  createdBy: User;
  actionType: ActionType;
  oldDataStr: string;
  newDataStr: string;
  newData: any;
  oldData: any;
}

export interface TrackChange {
  // ChangeLogData.java
  id: number;
  objectId: number;
  objectType: ObjectType;
  creationDate: Date;
  createdBy: User;
  actionType: ActionType;
  objectName: string;
}

export interface TrackChangesResponse {
  changeLogDataList: Array<TrackChange>;
  allItemsSize: number;
}

export enum ObjectType {
  WSD_CONSULTANT = 1,
  WSD_ORGANIZATION = 2,
}

export interface ObjectTypeI {
  name: ObjectType;
  translation: string;
  value: number;
}

export interface ListDiffAttI {
  translation: string;
  attributePath: string;
  attributeValue: string;
}



